import type { ReactNode } from "react";

export type LegalSection = {
  heading: string;
  body?: ReactNode;
  items?: string[];
};

type LegalPageProps = {
  title: string;
  intro: string;
  updatedLabel: string;
  updatedValue: string;
  sections: LegalSection[];
};

export function LegalPage({ title, intro, updatedLabel, updatedValue, sections }: LegalPageProps) {
  return (
    <main id="main-content" className="mx-auto min-w-0 max-w-3xl px-4 py-10 sm:px-6 sm:py-14">
      <header className="border-b border-[color:var(--color-border-subtle)] pb-6">
        <p className="text-sm text-[color:var(--color-fg-subtle)]">
          {updatedLabel}: {updatedValue}
        </p>
        <h1 className="mt-3 text-3xl font-semibold leading-tight text-[color:var(--color-fg-default)]">
          {title}
        </h1>
        <p className="mt-4 text-base leading-7 text-[color:var(--color-fg-muted)]">{intro}</p>
      </header>

      <div className="mt-8 space-y-8">
        {sections.map((section) => (
          <section key={section.heading} aria-labelledby={section.heading}>
            <h2
              id={section.heading}
              className="text-xl font-semibold leading-snug text-[color:var(--color-fg-default)]"
            >
              {section.heading}
            </h2>
            {section.body ? (
              <div className="mt-3 leading-7 text-[color:var(--color-fg-muted)]">
                {section.body}
              </div>
            ) : null}
            {section.items ? (
              <ul className="mt-3 list-disc space-y-2 ps-6 leading-7 text-[color:var(--color-fg-muted)]">
                {section.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            ) : null}
          </section>
        ))}
      </div>
    </main>
  );
}
